<template>
    <div>
        <div class="row mr-1 mb-3">
            <div
                class="col-12"
                align="right"
            >
<!--                <a-->
<!--                    :href="$store.state.api + 'download/import-model-vehicle'"-->
<!--                    target="_blank"-->
<!--                    class="btn btn-add"-->
<!--                >Modelo-->
<!--                 de-->
<!--                 Importação-->
<!--                </a>-->
<!--                <button-->
<!--                    class="btn btn-add"-->
<!--                    @click="openInput"-->
<!--                >-->
<!--                    Importar Veiculos-->
<!--                </button>-->
<!--                <input-->
<!--                    name="fileImport"-->
<!--                    id="fileImport"-->
<!--                    type="file"-->
<!--                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"-->
<!--                    style="display: none"-->
<!--                    value="null"-->
<!--                    @change="importFile"-->
<!--                />-->
                <a
                    :href="$store.state.api + 'export-vehicles-qrcode'"
                    target="_blank"
                    class="btn btn-add"
                >Exportar QRCodes
                </a
                >
            </div>
        </div>
        <base-crud
            :ref="'vehiclesCrud'"
            crudName="Cadastro de Veículos"
            newText="Novo Veículo"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="true"
            :dataForm="dataForm"
            :extra="extra"
            @bloquear="bloquear"
        ></base-crud>
    </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
import {getMessage} from "../../composables/message";

export default {
    data: function () {
        return {
            table: "vehiclesTable",
            pages: [],
            url: "",
            columns: [
                "id",
                "photo",
                "description",
                // "brand",
                "board",
                "model_year",
                "combustible",
                "branch_id",
                "vehicle_status_id",
                "current_km",
                "cost_center_id",
                "actions",
            ],
            tableData: [
                "id",
                "photo",
                "description",
                // "brand",
                "board",
                "model_year",
                "combustible",
                "branch_id",
                "current_km",
                "cost_center_id",
                "vehicle_status_id",
            ],
            options: {
                sortable: [
                    "id",
                    "photo",
                    "description",
                    "board",
                    "model_year",
                    "combustible",
                    "branch_id",
                    "vehicle_status_id",
                    "current_km",
                    "cost_center_id"
                ],
                filterByColumn: true,
                debounce: 1000,
                filterable: [
                    "id",
                    "description",
                    //   "brand",
                    "board",
                    "model_year",
                    "combustible",
                    "branch_id",
                    "vehicle_status_id",
                    "current_km",
                    "cost_center_id",
                ],
                pagination: {chunk: 10, dropdown: false, nav: "scroll"},
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                headings: {
                    id: "ID",
                    photo: "Foto do Veiculo",
                    description: "Descrição",
                    //   brand: "Marca",
                    board: "Placa",
                    model_year: "Ano",
                    combustible: "Combustível",
                    branch_id: "Filial",
                    vehicle_status_id: "Status",
                    current_km: "Km Atual",
                    cost_center_id: "Centro de Custo",
                    actions: "Ações",
                },
                texts: {
                    filterBy: "Filtrar",
                    defaultOption: "Selecione o Status",
                },
                listColumns: {
                    vehicle_status_id: [
                        {
                            id: "2",
                            text: "INDISPONÍVEL",
                        },
                        {
                            id: "1",
                            text: "DISPONÍVEL",
                        },
                    ],
                    cost_center_id: [], // Será populado dinamicamente
                },
                templates: {
                    vehicle_status_id: function (h, row, index) {
                        return row.vehicle_status
                            ? row.vehicle_status.description
                            : "Sem Status";
                    },
                    cost_center_id: function (h, row, index) {
                        return row.cost_center ? row.cost_center.description : "Veículo compartilhado";
                    },
                    branch_id: function (h, row, index) {
                        return row.branch ? row.branch.description : "Sem Status";
                    },
                },
                requestFunction: function (data) {
                    let requestData = {};

                    requestData.params = data;

                    if (this.$store.state.user.access_nivel === 1) {
                        requestData.params.department_id = this.$store.state.user.department_id
                    }

                    // Passa o filtro de centro de custos para o backend
                    if (data.query && data.query.cost_center_id) {
                        requestData.params.cost_center_id = data.query.cost_center_id;
                    }

                    let query = this.$parent.$parent.query(data.query);
                    requestData.params.query = "";
                    requestData.params.with = ["vehicle_status", "branch", "costCenter"];

                    return this.$http.get(this.url + "?" + query, requestData)
                        .then(function (response) {
                            return response;
                        })
                        .catch(function (e) {
                            this.dispatch("error", e);
                        }.bind(this));
                },
            },
            extra: [
                {
                    id: 1,
                    label: "",
                    class: "btn btn-crud block fas fa-ban",
                    title: "Bloqueio / Desbloqueio",
                    name: "bloquear",
                    icon: "fas fa-ban",
                },
            ],
            endPoint: "vehicles/",
            dataForm: {},
        };
    },
    methods: {
        makeFormData: function () {
            const self = this;
            let fd = new FormData();

            let fileImport = document.getElementById("fileImport");

            fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

            return fd;
        },
        importFile() {
            const self = this;
            let api = self.$store.state.api + "import-vehicles";

            let fd = self.makeFormData();

            self.$http
                .post(api, fd)
                .then((response) => {
                    self.$message(
                        "Sucesso",
                        `Informações guardadas com sucesso`,
                        "success"
                    );
                    self.showMessageImport = true;
                    self.$refs.vehiclesCrud.$refs.table.refresh();
                })
                .catch((error) => {
                    self.$message("Ops", error.response.data, "error");
                });
        },
        openInput() {
            document.getElementById("fileImport").click();
        },
        query: function (query) {
            let columns = {
                id: "id",
                description: "description",
                // brand: "brand",
                board: "board",
                model_year: "model_year",
                combustible: "combustible",
                branch_id: "branch[description]",
                current_km: "current_km",
                vehicle_status_id: "vehicle_status_id",
                cost_center_id: 'cost_center_id'

            };
            let filters = "orderByDesc=id&";
            $.each(query, function (index, value) {
                filters += columns[index] + "=" + value + "&";
            });
            return filters;
        },
        bloquear: function (props, row, index) {
            const self = this;
            self.save(props);
        },
        // Método para carregar centros de custos
        loadCostCenters() {
            const api = this.$store.state.api + 'cost-centers';
            this.$http.get(api, { params: { paginated: false, orderByAsc: 'erp_code' } })
                .then((response) => {
                    const costCenters = response.data.data || [];

                    // Adiciona opção "Veículo de Locação" para veículos sem centro de custos
                    this.options.listColumns.cost_center_id = [
                        { id: '-1', text: 'Veículo de Locação' },
                        ...costCenters.map(cc => ({
                            id: cc.id,
                            text: cc.erp_code
                        }))
                    ];
                })
                .catch((error) => {
                    console.error('Erro ao carregar centros de custos:', error);
                });
        },
        save(props) {
            const self = this;

            let api = self.$store.state.api + "vehicles/" + props.row.id;
            let fd = new FormData();

            fd.append("_method", "PATCH");

            let status =
                props.row.vehicle_status_id == 1
                    ? (props.row.vehicle_status_id = 2)
                    : (props.row.vehicle_status_id = 1);
            let board = props.row.board;

            fd.append("board", board);
            fd.append("vehicle_status_id", status);

            self.$http
                .post(api, fd)
                .then((response) => {
                    props.row.vehicle_status_id = status;
                    if (status == 1) {
                        self.$message("Sucesso", `Veículo Desbloqueado`, "success");
                        props.row.vehicle_status.description = "DISPONÍVEL";
                    } else {
                        self.$message("Sucesso", `Veículo Bloqueado`, "success");
                        props.row.vehicle_status.description = "INDISPONÍVEL";
                    }
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
    },
    components: {
        BaseCrud,
    },
    mounted: function () {
        this.loadCostCenters();
    },
};
</script>

<style scoped>
.VuePagination {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Vehicle/Crud.vue